import { useEffect } from 'react';

// Marks the current route as non-indexable (noindex, nofollow) for as long
// as it's mounted, restoring whatever <meta name="robots"> state existed
// before on unmount — so navigating elsewhere in the SPA doesn't leave the
// rest of the site noindexed. Done imperatively (not via react-helmet) since
// react-helmet 6's side-effect model doesn't reliably commit head mutations
// under React 19 — same reasoning as Disco.jsx's useSketchStyles.
const useNoIndex = () => {
  useEffect(() => {
    let tag = document.querySelector('meta[name="robots"]');
    const existed = !!tag;
    const previousContent = tag ? tag.getAttribute('content') : null;

    if (!tag) {
      tag = document.createElement('meta');
      tag.setAttribute('name', 'robots');
      document.head.appendChild(tag);
    }
    tag.setAttribute('content', 'noindex, nofollow');

    return () => {
      if (!existed) {
        tag.remove();
      } else {
        tag.setAttribute('content', previousContent);
      }
    };
  }, []);
};

export default useNoIndex;
